/* eslint-disable no-undef */
import CustomLayout from "./wrapPageElement";
import RootWrapper from "./rootWrapper";

export const wrapPageElement = CustomLayout;
export const wrapRootElement = RootWrapper;
